import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
const Services = () => {
  let Current = new Date();
  Current = Current.getHours();

  // if (Current >= 1 && Current < 18) {
  // return (
  // <div class="morning-css">
  // <div class="text-white p-5 	d-none d-sm-block">
  //     <div class="row text-center" id="footer-css">
  //     <div class="col-sm">
  //       <h4>About</h4>
  //       Arise,awake and donot stop until the goal is reached.
  //     </div>
  //     <div class="col-sm" >
  //       <h4>RR Leather </h4>
  //       <Link to={'/about'} id="f-link-css">About</Link><br/>
  //       <Link to={'/footcare'} id="f-link-css">Footcare</Link><br/>
  //       <Link to={'/service'} id="f-link-css">Services</Link><br/>
  //       <Link to={'/contact'} id="f-link-css">Contact</Link><br/>
  //     </div>
  //     <div class="col-sm">
  //       <h4>Contact</h4>
  //       <p>
  //       All types of Shoes and Sandals<br/>
  //       No 142, E Main Rd,Pammal,<br/>

  //       Chennai-600044,<br/>
  //       TamilNadu,<br/>
  //       </p>
  //     </div>

  //     </div>
  // </div>
  // <div class="container d-block d-sm-none">
  // <nav class="navbar navbar-light">
  //   <a class="navbar-brand" id="footer-icons" href="#">
  //   <i class="fa fa-phone"></i>
  //   </a>
  //   <a class="navbar-brand" id="footer-icons" href="#">
  //   <i class="fa fa-whatsapp"></i>
  //   </a>
  // </nav>
  // </div>
  // </div>
  // );
  // }
  // else{
  // return (
  // <div  class="night-css">
  // <div class="text-white p-5 	d-none d-sm-block">
  //     <div class="row text-center" id="footer-css">
  //     <div class="col-sm">
  //       <h4>About</h4>
  //       Arise,awake and donot stop until the goal is reached.
  //     </div>
  //     <div class="col-sm" >
  //       <h4>RR Leather </h4>
  //       <Link to={'/about'} id="f-link-css">About</Link><br/>
  //       <Link to={'/footcare'} id="f-link-css">Footcare</Link><br/>
  //       <Link to={'/service'} id="f-link-css">Services</Link><br/>
  //       <Link to={'/contact'} id="f-link-css">Contact</Link><br/>
  //     </div>
  //     <div class="col-sm">
  //       <h4>Contact</h4>
  //       <p>
  //       All types of Shoes and Sandals<br/>
  //       No 26, 6st Adem Nager,<br/>
  //       Nagalkeni,<br/>
  //       Chennai-600044<br/>
  //       </p>
  //     </div>
  //     </div>
  // </div>

  // <div class="container d-block d-sm-none">
  // <nav class="navbar navbar-light">
  //   <a class="navbar-brand" id="footer-icons" href="tel:919123510990">
  //   <i class="fa fa-phone"></i>
  //   </a>
  //   <a class="navbar-brand" id="footer-icons" href="https://wa.me/919123510990" target="_blank">
  //   <i class="fa fa-whatsapp"></i>
  //   </a>
  // </nav>
  // </div>
  // </div>
  // );
  // }

  return (
    <div class="container">
      <footer class="py-5">
        <div class="row">
          <div class="col-3">
            <h5>RR ORTHO</h5>
            <ul class="flex-column footer-rr">
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  Home
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  Services
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  Footcare
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  About
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          {/* <div class="col-6 col-md-2 mb-3">
            <h5>Section</h5>
            <ul class="flex-column footer-rr">
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  Home
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  Features
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  Pricing
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  FAQs
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="#" class="nav-link p-0 text-body-secondary">
                  About
                </a>
              </li>
            </ul>
          </div> */}
          <div class="col-3">
            <h5>Products</h5>
            <ul class="flex-column footer-rr">
              <li class="nav-item mb-2">
                <a href="/male-products" class="nav-link p-0 text-body-secondary">
                  Mens
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="/kids-products" class="nav-link p-0 text-body-secondary">
                  Kids
                </a>
              </li>
              <li class="nav-item mb-2">
                <a href="/female-products" class="nav-link p-0 text-body-secondary">
                  Ladies
                </a>
              </li>
            </ul>
          </div>
          <div class="col-6">
            <form>
              <h5>Drop Your Email Here</h5>
              <p style={{ fontSize: "16px" }}>
                We will get back to you shortly.
              </p>
              <div class="d-flex flex-column flex-sm-row w-100 gap-2">
                {" "}
                <label for="newsletter1" class="visually-hidden">
                  Email address
                </label>{" "}
                <input
                  id="newsletter1"
                  type="email"
                  class="form-control"
                  placeholder="Email address"
                />{" "}
                   <a
                                    href="mailto:sethugopi4@gmail.com?subject=This%20is%20the%20subject&body=This%20is%20the%20body">
                <button class="btn btn-primary" type="button">
                  Submit
                </button>{" "}
                </a>
              </div>
            </form>
          </div>
        </div>
        <div class="d-flex flex-column flex-sm-row justify-content-between py-4 my-4 border-top">
          <p style={{ fontSize: "16px" }}>
            &copy; 2025 RR ORTHO, Inc. All rights reserved.
          </p>
          <ul class="list-unstyled d-flex">
            <li class="ms-3">
            <a class="link-body-emphasis"href="https://wa.me/919123510990" target="_blank" aria-label="whatsapp">
                <i class="fab fa-whatsapp"></i>
              </a>
            </li>
            <li class="ms-3">
              <a class="link-body-emphasis"href="https://www.instagram.com/rr_ortho_care/" target="_blank" aria-label="insta">
                <i class="fab fa-instagram"></i>
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  );
};

export default Services;
